import React from 'react';
import {connect} from "react-redux";

import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";


class Notifications extends React.Component{

    render() {
        const admin = this.props.sessionData.loggedUser ? (this.props.sessionData.loggedUser.firstname && this.props.sessionData.loggedUser.surname) ? this.props.sessionData.loggedUser.firstname + " " + this.props.sessionData.loggedUser.surname : this.props.sessionData.loggedUser.nickname : "Neznámý uživatel";
        return (
            <div id="page-notifications" className="right-col" role="main">
                <div className="page-title">
                    <div className="title-left">
                        <h3>Notifikace</h3>
                    </div>
                    <div className="x-panel">
                        <div className="x-title">
                            <h2>Seznam notifikací</h2>
                            <div className="clearfix"/>
                        </div>
                        <div className="x-content">
                            <ul className="list-unstyled timeline">
                                {
                                    [...this.props.notifications].map((notification, index) => {
                                        let tag;
                                        switch (notification.messageType) {
                                            default:
                                                tag = 'Info';
                                                break;
                                            case 'info':
                                                tag = 'Info';
                                                break;
                                            case 'success':
                                                tag = 'Úspěch';
                                                break;
                                            case 'error':
                                                tag = 'Chyba';
                                                break;
                                            case 'warning':
                                                tag = 'Varování';
                                                break;
                                        }

                                        return (
                                            <li key={index}>
                                                <div className="block">
                                                    <div className="tags">
                                                        <a className={`tag tag-${notification.messageType}`}>
                                                            <span>{tag}</span>
                                                        </a>
                                                    </div>
                                                    <div className="block-content">
                                                        <h2 className="title">
                                                            {notification.title}
                                                        </h2>
                                                        <div className="byline">
                                                            <span>{notification.time}</span> by <a>{admin}</a>
                                                        </div>
                                                        <p className="excerpt">
                                                            {notification.message}
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                        )}
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
        toggleRead: (index) => dispatch(NotificationsActionCreators.toggleRead(index))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



/** WEBPACK FOOTER **
 ** ./src/containers/Notifications/index.js
 **/